module.exports = __webpack_public_path__ + "img/finish_home_960.4bd229ee.png";